<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-23 10:24 -->
<!-- Description:  -->
<template>
  <div>
    <div class="list-group mb-4">
      <div class="list-group-item list-group-item-action" v-for="item in list" :key="item.id">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1 text-capitalize">{{timeFilter(item.ini_date)}}</h5>
        </div>
        <div>
          <small>{{ item.employee_name }}</small>
        </div>
        <div class="mb-1 d-flex">
          <span class="mr-auto">{{ item.specialty_name }}</span>
          <AppointmentStatusBadge :status_id="item.status_id"></AppointmentStatusBadge>
        </div>

        <p>{{ item.commentary }}</p>

        <router-link class="btn btn-primary btn-sm" :to="{ name: 'dental.patient.treatment', params: {
          client_id: item.client_id,
          id: item.treatment_plan_id,
          }}">
          Ver Detalles
        </router-link>
      </div>
    </div>

  </div>
</template>
<script>
import DentalClinicService from '../service';
import AppointmentStatusBadge from "./AppointmentStatusBadge.vue";
import myMoment from "src/lt/utils/myMoment.js";

// script content
export default {
  name: "AppointmentCardList",
  components: {
    AppointmentStatusBadge,
  },

  // directives

  props: {
    client_id: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    list: []
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    this.reload();
  },

  methods: {
    async reload() {
      let res = await DentalClinicService.getQuotes({
        client_id: this.client_id,
      });
      this.list = res.data;
    },
    timeFilter(reg){
      return myMoment(reg).format("LLLL")
    }
    //
    //
  }
};
</script>
<style scoped></style>

